<template>
    <svg class="design-spinner" viewBox="0 0 50 50" :style="sizeStyle" aria-hidden="true">
        <circle class="spinner-track" cx="25" cy="25" r="19"/>
        <circle class="spinner-arc" cx="25" cy="25" r="19"/>
    </svg>
</template>

<script>
export default {
    name: 'DesignSpinner',
    props: {
        size: { type: Number, default: 0 }
    },
    computed: {
        sizeStyle() {
            return this.size ? { width: `${this.size}px`, height: `${this.size}px` } : null;
        }
    }
}
</script>

<style lang="scss" scoped>
.design-spinner {
    display: block;
    width: 100%;
    height: auto;
    animation: spinner-rotate 2s linear infinite;
}

.spinner-track,
.spinner-arc {
    fill: none;
    stroke-width: 6;
}

.spinner-track {
    stroke: rgba(0, 0, 0, 0.3);
}

.spinner-arc {
    stroke: $color-white-text;
    stroke-dasharray: 1, 120;
    stroke-dashoffset: 0;
    animation: spinner-dash 1.6s ease-in-out infinite;
}

@keyframes spinner-rotate {
    to {
        transform: rotate(360deg);
    }
}

@keyframes spinner-dash {
    0% {
        stroke-dasharray: 1, 120;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 80, 120;
        stroke-dashoffset: -30;
    }
    100% {
        stroke-dasharray: 80, 120;
        stroke-dashoffset: -118;
    }
}

@media (prefers-reduced-motion: reduce) {
    .design-spinner,
    .spinner-arc {
        animation-duration: 3s;
    }
}
</style>
